<template>
  <div>
    <div v-if="!isLogin">
      <div class="vx-row mb-8">
        <div class="vx-col">
          <h3>Pilih Loket</h3>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/3" v-for="(counter,i) in counters" :key="i">
          <vs-card>
            <div class="vx-row p-5">
              <div class="vx-col w-full text-center mb-5">
                <h3>{{counter.counter_name}}</h3>
                <p>{{counter.service_name}}</p>
              </div>
              <div class="vx-col w-full text-center">
                <vs-avatar size="70px" class="mb-3" :src="counter.user ? counter.user.avatar : ''"/>
              </div>

              <div
                v-if="counter.user"
                class="vx-col w-full text-center text-xl"
              >{{counter.user.name}}</div>
              <div v-else class="vx-col w-full flex justify-center text-lg">
                <vs-button
                  size="small"
                  icon-pack="feather"
                  icon="icon-send"
                  color="primary"
                  type="filled"
                  @click="selectCounter(counter.id)"
                >Pilih Loket</vs-button>
              </div>
            </div>
          </vs-card>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="vx-row justify-center">
        <div class="vx-col w-full flex justify-end mb-5">
          <vs-button
            color="primary"
            type="border"
            icon-pack="feather"
            @click="logout"
            icon="icon-log-out"
          >Keluar</vs-button>
        </div>
        <div class="vx-col w-full md:w-2/5">
          <caller
            :queues="queues"
            :counterId="currentCounter.id"
            :counterName="currentCounter.counter_name"
            :laperonService="laperonService"
            :bus="bus"
          ></caller>
        </div>
      </div>

      <section-list-queue
        :serviceId="currentCounter.service_id || null"
        menuType="secure"
        @callData="setQueueData"
        :bus="bus"
      />
    </div>

    <popup-counter-detail :active.sync="popupCounter" :counter="''" />
  </div>
</template>

<script>
import vSelect from "vue-select";
import PopupCounterDetail from "@/components/queue/PopupCounterDetail.vue";
import SectionListQueue from "@/components/queue/SectionListQueue.vue";
import Caller from "@/components/queue/caller/Caller";
import Vue from "vue";

export default {
  data() {
    return {
      status: "",
      popupTransfer: false,
      popupCounter: false,
      color: ["primary", "warning", "success"],
      isLogin: false,
      queues: [],
      queueCounter: [],
      currentCounter: null,
      laperonService : null,
      counters: [],
      bus: new Vue(),
    };
  },
  mounted() {
    this.init();
    this.setOnCounterLogin();
    // this.initEcho();
  },
  methods: {
    action(val) {
      this.status = val;
    },
    openTransfer() {
      this.popupTransfer = true;
    },
    openCounter() {
      this.popupCounter = true;
    },
    init() {
      this.getCounter();
    },
    getCounter() {
      this.$vs.loading();
      this.$http
        .get(`/app/secure/counter-process/my-counter`)
        .then((r) => {
          if (r.data.data.counter) {
            this.currentCounter = r.data.data.counter;
            this.setOnUpdateQueue(r.data.data.counter.service_id);
            this.isLogin = true;
          } else {
            this.$http.get(`/app/secure/counter-process/counter`).then((r) => {
              this.counters = r.data.data.counters;
            });
          }
        })
        .catch((e) => {
          this.parseLaravelErrors(e);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    selectCounter(id) {
      this.$vs.loading();
      this.$http
        .post(`/app/secure/counter-process/set-counter`, { counter_id: id })
        .then(() => {
          window.location.reload();
        })
        .catch(e => {
          this.parseError(e);
          this.$vs.loading.close();
          if(e.response.data.status == 422){
            window.setTimeout(function(){ 
              window.location.reload();
            },2000);
          }
        });
    },
    setQueueData(data) {
      this.queues = data;
    },
    setOnUpdateQueue(id) {
      this.$echo
        .private(`User.Queue.${id}`)
        .listen(".OnUpdateQueueEvent", () => {
          this.bus.$emit("reloadQueue");
        });
    },
    setOnCounterLogin() {
      this.$echo
        .private(`User.Counter.${this.$store.state.AppActiveUser.id}`)
        .listen(".OnCounterLoginEvent", () => {
          window.location.reload();
        });
    },
    logout() {
      this.$http
        .post("/app/secure/counter-process/counter/logout")
        .then(() => {
          window.location.reload();
        })
        .catch((e) => {
          alert(e);
        });
    },
  },
  components: {
    vSelect,
    PopupCounterDetail,
    SectionListQueue,
    Caller,
  },
};
</script>
>
